export default "__VITE_ASSET__d1cecdfd__"